import { getShiftsAndCrews } from "@/pages/delays/delays-report/repositories/DelaysReportRepository";
import { getMomentTz } from "@dexteel/mesf-core";
import {
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Paper,
	Select,
} from "@material-ui/core";
import { DatePicker } from "@mui/x-date-pickers";
import { get } from "lodash-es";
import { Moment } from "moment-timezone";
import React, { useEffect, useState } from "react";

type Props = {
	onFilterChange: (
		fromDate: Date,
		toDate: Date,
		shift: string | null,
		crew: string | null,
	) => void;
	initialFromDate: Date;
	initialToDate: Date;
	filterShift: string | null;
	onFilterShiftChange: (shift: string | null) => void;
	filterCrew: string | null;
	onFilterCrewChange: (crew: string | null) => void;
};

const moment = getMomentTz();

export const Filters: React.FC<Props> = ({
	onFilterChange,
	initialFromDate,
	initialToDate,
	filterShift,
	onFilterShiftChange,
	filterCrew,
	onFilterCrewChange,
}) => {
	const [fromDate, setFromDate] = useState<Date>(initialFromDate);
	const [toDate, setToDate] = useState<Date>(initialToDate);
	const [shiftsList, setShiftsList] = useState<any[]>([]);
	const [crewsList, setCrewsList] = useState<any[]>([]);

	useEffect(() => {
		const fetchOptions = async () => {
			const res = await getShiftsAndCrews();
			if (res.ok) {
				const rowsSource = get(res, "data", []);
				const shifts = rowsSource?.tables[0].rows;
				const crews = rowsSource?.tables[1].rows;
				setShiftsList(shifts);
				setCrewsList(crews);
			}
		};
		fetchOptions();
	}, []);

	const handleFromDateChange = (value: Moment | null) => {
		if (value) {
			const newDate = value.toDate();
			setFromDate(newDate);
			onFilterChange(newDate, toDate, filterShift, filterCrew);
		}
	};

	const handleToDateChange = (value: Moment | null) => {
		if (value) {
			const newDate = value.toDate();
			setToDate(newDate);
			onFilterChange(fromDate, newDate, filterShift, filterCrew);
		}
	};

	const handleShiftChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const rawValue = event.target.value as string;
		const newShift = rawValue === "" ? null : rawValue;
		onFilterShiftChange(newShift);
		onFilterChange(fromDate, toDate, newShift, filterCrew);
	};

	const handleCrewChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const rawValue = event.target.value as string;
		const newCrew = rawValue === "" ? null : rawValue;
		onFilterCrewChange(newCrew);
		onFilterChange(fromDate, toDate, filterShift, newCrew);
	};

	return (
		<Paper
			style={{
				minWidth: "650px",
				margin: "20px 0px",
				padding: "20px",
				height: "90px",
				display: "flex",
				justifyContent: "center",
			}}
		>
			<Grid container alignItems="center" spacing={2}>
				<Grid item>
					<DatePicker
						label="From"
						format="MM/DD/YYYY"
						value={moment(fromDate)}
						onChange={handleFromDateChange}
						slotProps={{
							textField: {
								variant: "outlined",
								size: "small",
								inputProps: { style: { width: "110px", padding: 10 } },
							},
						}}
					/>
				</Grid>
				<Grid item>
					<DatePicker
						label="To"
						format="MM/DD/YYYY"
						value={moment(toDate)}
						onChange={handleToDateChange}
						disableFuture
						slotProps={{
							textField: {
								variant: "outlined",
								size: "small",
								inputProps: { style: { width: "110px", padding: 10 } },
							},
						}}
					/>
				</Grid>
				<Grid item>
					<FormControl variant="outlined" size="small" style={{ width: 110 }}>
						<InputLabel id="shift-select-label">Shift</InputLabel>
						<Select
							labelId="shift-select-label"
							id="shift-select"
							value={filterShift ?? ""}
							onChange={handleShiftChange}
							label="Shift"
						>
							<MenuItem key="shift-all" value="All">
								All
							</MenuItem>
							{shiftsList.map((shift: any) => (
								<MenuItem key={`shift-${shift.Shift}`} value={shift.Shift}>
									{shift.Shift}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Grid>
				<Grid item>
					<FormControl variant="outlined" size="small" style={{ width: 110 }}>
						<InputLabel id="crew-select-label">Crew</InputLabel>
						<Select
							labelId="crew-select-label"
							id="crew-select"
							value={filterCrew ?? ""}
							onChange={handleCrewChange}
							label="Crew"
						>
							<MenuItem key="crew-all" value="All">
								All
							</MenuItem>
							{crewsList.map((crew: any) => (
								<MenuItem key={`crew-${crew.Crew}`} value={crew.Crew}>
									{crew.Crew}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
		</Paper>
	);
};
